var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticStyle:{"margin-top":"3vw"},attrs:{"size":50,"width":5,"color":"blue","indeterminate":""}}),_c('p',{staticClass:"black--text",attrs:{"id":"connection_msg"}},[_vm._v(" Connecting to the server ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }